import CsatByDeviceTagWidget from './CsatByDeviceTagWidget';
export default CsatByDeviceTagWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/CsatByDeviceTagWidget/index.js